<template>
<div class="bk-gray-dark  trick-3">
  <img src="../../../assets/images/preparare-formule/truc3.png" alt="/">
    <p>3. Respectă ordinea în care adaugi pudra</p>
    <span>Adaugă pudra numai după ce ai turnat apa deja în biberon/cănuță ca să eviți formarea cocoloașelor ce rămân nedizolvate.</span>
</div>
</template>

<script>
export default {
    name: 'Ordine',

    data() {
        return {}
    },
}
</script>
<style lang="scss" scoped>
.trick-3 p{
  margin-top: 50px;
  color: #17479E;
  font-size: 20px;
  font-weight: 600;
}

.trick-3 span{
  font-size: 16px;
  color: #17479e;
}

.trick-3 img {
  position: absolute;
  left: 20px;
  top: -60px;
}
.bk-blue-light {
    background: #F1F8FF;
    border-radius: 20px;
    padding-top: 65px;
    width: 420px !important;
    min-height: 380px;
    max-height: 380px;
    position: relative;
    @media only screen and (max-width: 992px) {
        width: 100% !important;
        max-height: 100%;
        min-height: auto;
        padding-top: 45px;
    }

    p {
        font-size: 16px;
        font-weight: 600;
        color: #029FE3;
    }

    span {
        font-size: 14px;
        font-weight: 500;
        color: #029FE3;
    }
}

@media screen and (max-width: 526px){
  .trick-3 img{
    width: 89px !important;
    height: 89px !important;
    top: -40px;
  }
}

</style>
